import { Component, Prop, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import { INACTIVE_APPLICATION_QUERY } from "@/graphql/inactive-application-query";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import {
  FormFieldContents,
  InactiveApplicationData,
} from "@/models/inactive-application/inactive-application.interface";
import { utils } from "@/utils/utils";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputTextAreaComponent from "../input-textarea/input-textarea.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SingleCheckboxButton from "../single-checkbox-button/single-checkbox-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import { inactiveFormApi } from "@/providers/apis/inactive-form";
import moment from "moment";
import { User } from "@/models/common-interface/common.interface";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import EditHistoryComponent from "../edit-history/edit-history.component.vue";

@Component({
  name: "b-preview-form",
  components: {
    AppLoaderComponent,
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-single-checkbox": SingleCheckboxButton,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-textarea": InputTextAreaComponent,
    "b-form-upload-file": FileUploadComponent,
    EditHistoryComponent,
    ErrorPopupComponent,
  },
})
export default class InactivePreviewForm extends Vue {
  @Prop()
  public payloadDataAll: any;
  @Prop()
  public previewData: any;
  @Prop()
  public tabSelect: any;
  @Prop()
  public isReviewerPreviewForm!: boolean;
  @Prop()
  public progressStatus: any;
  @Prop()
  public isUserApplication!: boolean;
  @Prop()
  public isMigrationForm!: boolean;
  @Prop()
  public applicantPreviewForm: any;

  public formData: FormFieldContents[] = [];
  public applicationData: Array<InactiveApplicationData> = [];
  public userDetails: User = {} as User;
  public currentRoute = "";
  public editParentSlug = "";
  public isFieldsReferesh = "false";
  public isClickSavebtn = "false";
  public changesCount = 0;
  public vaildFile = true;
  public isFileValid = false;
  public isMobileView = false;
  public isEditReviewerForm = false;
  public disabled = true;
  public checkValidation = false;
  public isLargeLoading = false;
  public isLoading = false;
  public editApplication = false;
  public isEdited = false;
  public isInvalidComment = false;
  public isConfirm = false;
  public editIndex!: number;
  public limitationList: any;
  public previewPayload: any = {};
  public originalData: any = {};
  public fileData: File[] = [];
  public editedFields: any[] = [];
  public editedFormNames: string[] = [];
  public notFilesUploadedKeyNames: string[] = [];
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public errorMessage = "";

  public editHistoryComments = {
    comment: "",
    dateTime: "",
    editorDetails: {
      name: "",
      email: "",
      userId: "",
    },
  };

  public getCurrentParentSlug: any = {
    "basic-details": "certificationInActiveBasicDetails",
    signature: "certificationInactiveSignature",
  };
  public async created() {
    this.userDetails = utils.getUserDetails();
    this.$validator.extend(
      "tagsMaxLength",
      utils.customValidator.tagsValidation
    );
    this.isLoading = true;
    if (utils.checkIsMobileView() || utils.checkIsTabView()) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
    this.currentRoute = this.$route.path;
    let payloadStorage: any = localStorage.getItem("inactiveFormPayload");
    if (payloadStorage && this.currentRoute.split("/")[1] === "form") {
      payloadStorage = JSON.parse(payloadStorage);
      this.previewPayload = { ...payloadStorage };
      this.previewPayload.certificationInActiveBasicDetails.fullName = `${payloadStorage.certificationInActiveBasicDetails.firstName} ${payloadStorage.certificationInActiveBasicDetails.lastName}`;
      const fullAddress = utils.addressBuilder(
        payloadStorage,
        "certificationInActiveBasicDetails",
        "default"
      );
      this.previewPayload.certificationInActiveBasicDetails.fullAddress =
        fullAddress;
    } else {
      this.previewPayload = this.previewData;
    }
    this.$apollo
      .query({
        query: gql`query ${INACTIVE_APPLICATION_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.inactiveApplications.data;
        this.formData = this.applicationData[0].attributes.form_fields;
        this.limitationList = this.formData.length - 1;
        this.isLoading = false;
      });
    this.originalData = JSON.parse(JSON.stringify(this.previewPayload));
  }

  public fileValid(event: any) {
    this.vaildFile = event;
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }
  public onCilckSave() {
    this.checkValidation = true;
    this.isFileValid = !this.isFileValid;
    this.$validator.validate().then(async (validate) => {
      if (validate && this.vaildFile && !this.notFilesUploadedKeyNames.length) {
        if (this.currentRoute.split("/")[2] === "my-application") {
          const id = this.applicantPreviewForm.id;
          this.isLargeLoading = true;
          inactiveFormApi
            .updatePeerReviewerInactiveForm(this.previewPayload, id)
            .then(() => {
              this.disabled = true;
              this.editApplication = false;
              this.isLargeLoading = false;
              this.isEditReviewerForm = false;
              const data = {
                isUpdateData: true,
                isUpdateEmail: false,
              };
              this.$emit("getPeerUpdatedData", data);
              this.$emit("isEditForm", false);
            })
            .catch((error: any) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          this.editApplication = true;
          this.isClickSavebtn = this.changeStateForFieldUpdate(
            this.isClickSavebtn
          );
        }
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  public changeStateForFieldUpdate(value: string) {
    if (value === "false") {
      return "true";
    } else {
      return "false";
    }
  }

  public closeSidebar() {
    this.editApplication = false;
  }

  public editedPreviewPayloadData(event: any) {
    if (event) {
      this.previewPayload = event;
    }
  }

  public isConfirmChanges(event: boolean) {
    this.isConfirm = event;
    if (this.isConfirm) {
      const id = this.$route.path.split("/")[3];
      this.isLargeLoading = true;
      this.checkValidation = false;
      this.previewPayload.certificationInActiveBasicDetails.fullName = "";
      this.previewPayload.certificationInActiveBasicDetails.fullAddress = "";
      inactiveFormApi
        .updateReviewerInactiveForm(this.previewPayload, id)
        .then(() => {
          this.editApplication = false;
          this.isLargeLoading = false;
          this.isEditReviewerForm = false;
          this.$emit("getUpdatedData");
          this.$emit("isEditForm", false);
          this.$emit("isUpdateForm", true);
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
          this.$bvModal.show("error-modal-center");
          setTimeout(() => {
            this.$bvModal.hide("error-modal-center");
          }, 3000);
        });
    }
  }

  public isRevertedChanges(event: boolean) {
    if (event === true) {
      this.$emit("getUpdatedData");
      this.$emit("isEditForm", false);
    }
  }

  onCilckEdit(index: number) {
    this.editIndex = index;
    this.isEditReviewerForm = true;
    this.$emit("isEditForm", true);
  }

  onCancelEdit() {
    this.notFilesUploadedKeyNames = [];
    this.isEditReviewerForm = false;
    this.editApplication = false;
    if (this.currentRoute.split("/")[2] === "my-application") {
      this.$emit("isEditForm", false);
      this.$emit("getPeerUpdatedData", false);
    } else {
      this.$emit("getUpdatedData");
      this.$emit("isEditForm", false);
    }
  }

  editForm(slug: string) {
    this.$emit("applicationSlug", slug);
  }
  fieldUpdate(inputName: string) {
    if (!this.isEditReviewerForm && !this.isReviewerPreviewForm) {
      const nameNotVisiable = [
        "firstName",
        "lastName",
        "addressLine1",
        "addressLine2",
        "state",
        "city",
        "zip",
      ];
      return nameNotVisiable.includes(inputName);
    } else {
      const nameNotVisiable = !this.isEditReviewerForm
        ? [
            "firstName",
            "lastName",
            "addressLine1",
            "addressLine2",
            "state",
            "city",
            "zip",
          ]
        : ["fullName", "fullAddress"];
      return nameNotVisiable.includes(inputName);
    }
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public emptyEvent() {
    return;
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
}
